import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M8.71 11.71l2.59 2.59c.39.39 1.02.39 1.41 0l2.59-2.59c.63-.63.18-1.71-.71-1.71H9.41c-.89 0-1.33 1.08-.7 1.71z"
}), 'ArrowDropDownRounded');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ArrowDropDownRounded.js
// module id = 2090
// module chunks = 2